import { rest } from 'msw';
import { AGENTS_API_URL } from '../../config';
import { generateAgentInteractionFaker } from '../fixtures/logistics.faker';

export const logisticsHandler = [
    rest.post(AGENTS_API_URL + '/v2/logistics/assistant', (req, res, ctx) => {
        const body = req.body as { query?: string }; // Explicitly type req.body
        return res(
            // Respond with a 200 status code
            ctx.status(200),
            ctx.json({ ...generateAgentInteractionFaker(), query: body.query ?? '' }),
        );
    }),
];
